import { type GetAllSystemConfigsRes } from '../entity/api/routes/system-config';
import { apiRequest } from './request';

export async function getAllSystemConfigs() {
  return apiRequest<GetAllSystemConfigsRes>('/system-config/list', 'GET', false);
}
